export default "__VITE_ASSET__8064a6d7__"